module.exports = __webpack_public_path__ + "assets/img/title-7a783c69.png";